var _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartRightImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 500,
    viewBox: "0 0 690 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "start-right-image_svg__mask0_1214_32096",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 690,
    height: 704
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h690v704H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#start-right-image_svg__mask0_1214_32096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.229-10.323c77.171 85.52 177.584 155.002 302.153 163.446 79.482 5.554 158.977-12.572 228.436-52.086-48.966 63.155-78.168 139.287-83.91 218.758-8.856 118.787 39.385 226.21 108.697 310.532 3.373 3.889 6.594 7.909 9.948 11.777l11.525 13.291 38.56-33.436c5.075-4.401 10.058-8.909 14.911-13.566 71.422-68.184 120.801-162.963 128.567-267.365 8.227-110.605-60.072-249.938-126.711-327.744l-.259-.299C692.431-64.15 564.344-151.339 453.608-158.863c-106.83-7.279-209.876 30.041-288.075 93.582L117.038-23.23l11.191 12.907zm724.042 354.051c-.185-.214 0 0 0 0z",
    fill: "#fff"
  }))));
}
export default SvgStartRightImage;